// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type DispatchCustomerMatchInfo,
  type DispatchCustomerMatchInfoWireFormat,
  NewDispatchCustomerMatchInfo,
} from '../DispatchCustomerMatchInfo/DispatchCustomerMatchInfo';
import type Enums from '../Enums';

export class IgnoredDispatchCustomer {
  readonly id: string;
  readonly dispatchCustomerName: string;
  readonly dispatchCustomerCode: string | null | null;
  readonly companyId: string | null;
  readonly companyName: string | null;
  readonly integrationId: string | null;
  readonly integrationType: Enums.IntegrationType | null;
  readonly matchInfo: DispatchCustomerMatchInfo[] | null;
  readonly ignoredBy: string;
  readonly ignoredDate: DateTime;
  readonly ignoredType: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.dispatchCustomerName =
      data.dispatchCustomerName === undefined ? '' : data.dispatchCustomerName;
    this.dispatchCustomerCode =
      // eslint-disable-next-line no-nested-ternary
      data.dispatchCustomerCode ?? null;
    this.companyId = data.companyId === undefined ? null : data.companyId;
    this.companyName = data.companyName === undefined ? null : data.companyName;
    this.integrationId = data.integrationId === undefined ? null : data.integrationId;
    this.integrationType = data.integrationType === undefined ? null : data.integrationType;
    this.matchInfo =
      // eslint-disable-next-line no-nested-ternary
      (data.matchInfo ?? null) === null
        ? null
        : (data.matchInfo ?? []).map((matchInfo: any) => NewDispatchCustomerMatchInfo(matchInfo));
    this.ignoredBy = data.ignoredBy === undefined ? '' : data.ignoredBy;
    this.ignoredDate = DateHelpers.ParseServerDateTime(data.ignoredDate);
    this.ignoredType = data.ignoredType === undefined ? '' : data.ignoredType;
  }

  static zero(): IgnoredDispatchCustomer {
    const zeroValues: ExcludeMethodsDeep<IgnoredDispatchCustomer> = {
      id: NIL_UUID,
      dispatchCustomerName: '',
      dispatchCustomerCode: null,
      companyId: null,
      companyName: null,
      integrationId: null,
      integrationType: null,
      matchInfo: null,
      ignoredBy: '',
      ignoredDate: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      ignoredType: '',
    };
    return new IgnoredDispatchCustomer(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type IgnoredDispatchCustomerWireFormat = {
  id: string;
  dispatchCustomerName: string;
  dispatchCustomerCode: string | null | null;
  companyId: string | null;
  companyName: string | null;
  integrationId: string | null;
  integrationType: string | null;
  matchInfo: DispatchCustomerMatchInfoWireFormat[] | null;
  ignoredBy: string;
  ignoredDate: string;
  ignoredType: string;
};

type NewIgnoredDispatchCustomerProps = PartialDeep<
  IgnoredDispatchCustomer,
  { recurseIntoArrays: true }
>;
export const NewIgnoredDispatchCustomer: (
  props: NewIgnoredDispatchCustomerProps,
) => IgnoredDispatchCustomer = (props) => new IgnoredDispatchCustomer(props);

type NewIgnoredDispatchCustomerFromWireFormatProps = PartialDeep<
  IgnoredDispatchCustomerWireFormat,
  { recurseIntoArrays: true }
>;
export const NewIgnoredDispatchCustomerFromWireFormat: (
  props: NewIgnoredDispatchCustomerFromWireFormatProps,
) => IgnoredDispatchCustomer = (props) => new IgnoredDispatchCustomer(props);
